import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

  const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/projects',
    name: 'Projects',
    props: true,
    component: () => import(/* webpackChunkName: "Projects" */ '../views/Projects.vue'),
  },
  {
    path: '/cellarmaster',
    name: 'cellarmaster',
    props: true,
    component: () => import(/* webpackChunkName: "Cellarmaster" */ '../views/Cellarmaster.vue'),
  },
  {
    path: '/fencify',
    name: 'fencify',
    props: true,
    component: () => import(/* webpackChunkName: "Fencify" */ '../views/Fencify.vue'),
  },
  {
    path: '/rosewood',
    name: 'rosewood',
    props: true,
    component: () => import(/* webpackChunkName: "Rosewood" */ '../views/Rosewood.vue'),
  },
  {
    path: '/passman',
    name: 'passman',
    props: true,
    component: () => import(/* webpackChunkName: "Passman" */ '../views/Passman.vue'),
  },
  {
    path: '/shoppies',
    name: 'shoppies',
    props: true,
    component: () => import(/* webpackChunkName: "Shoppies" */ '../views/Shoppies.vue'),
  },
  {
    path: '/photo-share',
    name: 'photo-share',
    props: true,
    component: () => import(/* webpackChunkName: "Photo Share" */ '../views/PhotoShare.vue'),
  },
  {
    path: '/portfolio',
    name: 'portfolio',
    props: true,
    component: () => import(/* webpackChunkName: "Portfolio" */ '../views/Portfolio.vue'),
  },
  // {
  //   path: '/contact',
  //   name: 'Contact',
  //   component: () => import(/* webpackChunkName: "Contact" */ '../views/Contact.vue')
  // },
  {
    path: '/about',
    name: 'About',
    component: () => import(/* webpackChunkName: "About" */ '../views/About.vue')
  },
  {
    path: '*',
    redirect: {
      name: 'Home'
    }
  },
]

const router = new VueRouter({
  mode: 'history',
  routes
})

export default router
